module.exports = __webpack_public_path__ + "img/mandiri.cc60c633.png";